import { ApplicationState } from '@app/store'
import { actionCreators, IListingSelectorState, selectError, selectIsLoading, selectListings } from '../modules/listingSelector'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ListingSelector } from '../components/ListingSelector'

export default connect(
  createStructuredSelector<ApplicationState, IListingSelectorState>({
    listings: selectListings(),
    error: selectError(),
    isLoading: selectIsLoading(),
  }),
  actionCreators,
)(ListingSelector)
